/** @type {Record<string, string>} */
export const VIDEO_URL_OVERRIDES = {
  // —— Story section (Showcase) ——
  "jar_compiled_2.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6Au5wD5dd0Glv5yd2XNY3sUiFSmZHRcDhC1QfP",
  "jar_compiled.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AcTwUoKK7eUI1PqFTKaZkAubtQyHzwOM6oBgi",

  // —— France (Paris) ——
  "france/Clear_Morning.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6ArELaLcWCaHc7roRBkqf6WyIe9VYZPJzOQ3N8",
  "france/Clear_Noon.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6Ah4v1lokFbyZ4a2AXcgDRlHojLwIBKYx9Sqde",
  "france/Clear_Night.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AUjEH6bySVDyHk9Tm32XzKs7j8brtApwovMhB",
  "france/Cloudy_Grey.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AHsQaEW5FoOW9s3t51X7zpu0dhRTDjafw8QVL",
  "france/Cloudy_Morning.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6ACwEuf0oXSPrcApN9uo1Lfb3zwVGKRF0yOkjC",
  "france/Cloudy_Noon.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AmF3Is3uV5nTdYy2jBEoLbqhaDlWfRXA31QZi",
  "france/Cloudy_Night.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AZan2m1z8zhXKlDVIANMQm0y2rncdtYkTWF8e",
  "france/Drizzle_Grey.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6Ang77e3xLQk5aEsvX8gHDRbrhUNmGtwfVyz2J",
  "france/Drizzle_Night.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AcsQvMi7eUI1PqFTKaZkAubtQyHzwOM6oBgi2",
  "france/Haze_Grey.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6Ad377ktQcABvHVP6hNgt8YbpuIa0lGJTQioq4",
  "france/Haze_Night.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AFWdBelFAZydo1TGMgObfceDpsavIxiY59RAm",
  "france/Thunderstorm_Grey.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AyGy8cvSUgMjRbFALoPHuwDkGzT5nq7ps49BV",
  "france/Thunderstorm_Night.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AtG8YBQaIEdvxfgplj8hMZWRPFXbL2UJoV5ir",
  "france/Snow_Grey.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AUVgYYmRySVDyHk9Tm32XzKs7j8brtApwovMh",
  "france/Snow_Cloudy_Night.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6Ay4MvHDYSUgMjRbFALoPHuwDkGzT5nq7ps49B",

  // —— Germany (Berlin) — same filenames, different folder ——
  "germany/Clear_Morning.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AXQPgF7qBRGHIUW30vwbrCZgikPFVax4DOJqn",
  "germany/Clear_Noon.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AeuWO7fTXCM7oEWrgj1JbDfQVNq6B9ZSGIYwu",
  "germany/Clear_Night.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6A6CeVhQGbFEofU8DmqiKhSxdgAp3zNjPr4kJs",
  "germany/Cloudy_Grey.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6Awvqmztnp87N5kFy3xXlCc6Ra1MIYh2vjZSAi",
  "germany/Cloudy_Morning.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AQYEj3Lm7qTNYMljZDBLIymezaJoGgcd5QXb3",
  "germany/Cloudy_Noon.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6A5RgRokfNRih2jXlu1Dfz3Epg7oa4JZCLs8nV",
  "germany/Cloudy_Night.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6A5o3j4uGfNRih2jXlu1Dfz3Epg7oa4JZCLs8n",
  "germany/Drizzle_Grey.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AoqJ6bdZC0u9gtj2ZJDVWwTbcrqHM5QLyAUpR",
  "germany/Drizzle_Night.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AWPmjvZclYRte3FvMxpdB6srkAyf4TbqU5JmL",
  "germany/Haze_Grey.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6ADsd3ipjMmjFZ9wHCtg2hzIodxaE5rDskqlV4",
  "germany/Haze_Night.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AQqPeIOm7qTNYMljZDBLIymezaJoGgcd5QXb3",
  "germany/Thunderstorm_Grey.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6A0jPvOsHQ45LpgIreKYFaNflREzB1b6TiDGXx",
  "germany/Thunderstorm_Night.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AmnUVyNuV5nTdYy2jBEoLbqhaDlWfRXA31QZi",
  "germany/Snow_Grey.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6A6xqoOHGbFEofU8DmqiKhSxdgAp3zNjPr4kJs",
  "germany/Snow_Cloudy_Night.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AduGyStvQcABvHVP6hNgt8YbpuIa0lGJTQioq",

  // —— Indonesia (Jakarta) ——
  "indonesia/Morning_Clear_1080.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6A7bs79OeZAQmd8W6kS9pIEVzLlaebUNrM4sOo",
  "indonesia/Noon_Clear_1080.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6A4jgBlKsp3gqxof2H0wtWbpjFrJMRZsDY61hu",
  "indonesia/Night_Clear_1080.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6A8bFG8eP4nUbETxIr6kPlActRdm0wBDCjgesQ",
  "indonesia/Morning_Cloudy_1080.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AQ06OvW9m7qTNYMljZDBLIymezaJoGgcd5QXb",
  "indonesia/Noon_Cloudy_1080.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AlpwF7wBGRB7KWdo5gxDCSNhmVeZfFkrU2q3n",
  "indonesia/Night_Cloudy_1080.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6Ar0sf8YWCaHc7roRBkqf6WyIe9VYZPJzOQ3N8",
  "indonesia/Morning_Noon_Rain_1080.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6ASyfixeVpRDgKsBNH4XhwzikxuvdrbaC5WZ78",
  "indonesia/Night_Rain_1080.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AnVC4Z9xLQk5aEsvX8gHDRbrhUNmGtwfVyz2J",
  "indonesia/Morning_Haze_1080.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6A1mwuhzJWM6miy1BpAxgK2el0HXTtIuwLjsGQ",
  "indonesia/Noon_Haze_1080.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6A4jFZDTnp3gqxof2H0wtWbpjFrJMRZsDY61hu",
  "indonesia/Night_Haze_1080.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6Ao2gAkEC0u9gtj2ZJDVWwTbcrqHM5QLyAUpR6",
  "indonesia/Morning_Noon_Thunderstorm_1080.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6A7d5woU1eZAQmd8W6kS9pIEVzLlaebUNrM4sO",
  "indonesia/Night_Thunderstorm_1080.mp4": "https://4q8n7vzwg7.ufs.sh/f/JERCCZl9kj6AmHq1v7YuV5nTdYy2jBEoLbqhaDlWfRXA31QZ",
};

const FOLDER_FILE_SUFFIX = {
  france: "_fr",
  germany: "_de",
  indonesia: "_id",
};

export function resolveAnimationFileName(folder, file) {
  const suffix = FOLDER_FILE_SUFFIX[folder];
  if (!suffix || !/\.mp4$/i.test(file)) return file;
  return file.replace(/\.mp4$/i, `${suffix}.mp4`);
}

function cdnBase() {
  const base = process.env.REACT_APP_VIDEO_CDN_BASE;
  return base ? base.replace(/\/$/, "") : "";
}

function localAnimationPath(folder, file) {
  const resolved = resolveAnimationFileName(folder, file);
  const publicUrl = process.env.PUBLIC_URL || "";
  return `${publicUrl}/animation/${folder}/${resolved}`;
}

/**
 * URL for live weather jar clips (used by weather.js).
 * @param {string} folder — france | germany | indonesia
 * @param {string} file — e.g. Clear_Morning.mp4
 */
export function getAnimationVideoUrl(folder, file) {
  const key = `${folder}/${file}`;
  const override = VIDEO_URL_OVERRIDES[key];
  if (override) return override;

  const base = cdnBase();
  if (base) {
    const resolved = resolveAnimationFileName(folder, file);
    return `${base}/${folder}/${resolved}`;
  }

  return localAnimationPath(folder, file);
}

/**
 * URL for story-section compiled jar videos (used by Showcase.js).
 * @param {"jar_compiled_2.mp4" | "jar_compiled.mp4"} name
 */
export function getStoryVideoUrl(name) {
  const override = VIDEO_URL_OVERRIDES[name];
  if (override) return override;

  if (name === "jar_compiled_2.mp4" && process.env.REACT_APP_STORY_VIDEO_LEFT) {
    return process.env.REACT_APP_STORY_VIDEO_LEFT;
  }
  if (name === "jar_compiled.mp4" && process.env.REACT_APP_STORY_VIDEO_RIGHT) {
    return process.env.REACT_APP_STORY_VIDEO_RIGHT;
  }

  const base = cdnBase();
  if (base) return `${base}/${name}`;

  const publicUrl = process.env.PUBLIC_URL || "";
  return `${publicUrl}/animation/${name}`;
}
